import serverCall from "../../serverCall";

const CreateHighScore = async (data) => {
  const response = await serverCall.post("/high-score/create/admin", data);
  return response;
};
const GetHighScore = async (status, search, page, limit, type) => {
  const response = await serverCall.get(
    `/high-score/find-all?highScoreStatus=${status}&search=${search}&page=${
      page === undefined ? 1 : page
    }&limit=${limit}&type=${type}`
  );
  return response;
};

const DeleteHighScore = async (status) => {
  const response = await serverCall.delete(
    `/high-score/admin?highScoreStatus=${status}`
  );
  return response;
};
const DeleteHighScoreSingle = async (status, id) => {
  const response = await serverCall.delete(
    `/high-score/admin?highScoreStatus=${status}&highScoreId=${id}`
  );
  return response;
};
const GetHighScoreSingle = async (id) => {
  const response = await serverCall.get(
    `/high-score/find-one/admin?highScoreId=${id}`
  );
  return response;
};
const UpdateHighScoreSingle = async (id, data) => {
  const response = await serverCall.patch(
    `/high-score/update/admin?highScoreId=${id}`,
    data
  );
  return response;
};

const HighScoreService = {
  GetHighScore,
  CreateHighScore,
  DeleteHighScore,
  DeleteHighScoreSingle,
  GetHighScoreSingle,
  UpdateHighScoreSingle,
};

export default HighScoreService;
